import { Injectable } from '@angular/core';
import { PublicPatrimonialClient } from '../../models/patrimonial';

@Injectable({
  providedIn: 'root'
})
export class PatrimonialContextService {
  patrimonialJWT = '';
  patrimonialsClientInfo = {} as PublicPatrimonialClient;

  constructor() {}

  setPatrimonialJWT(value: string) {
    this.patrimonialJWT = value;
  }

  getPatrimonialJWT() {
    return this.patrimonialJWT;
  }

  setPatrimonialsClientInfo(value: PublicPatrimonialClient) {
    this.patrimonialsClientInfo = value;
  }

  getPatrimonialsClientInfo() {
    return this.patrimonialsClientInfo;
  }
}
